module.exports = __webpack_public_path__ + "img/banner-m109.a1dc4903.png";